// extracted by mini-css-extract-plugin
export default {"wrapper":"mobile-featured-link-module--wrapper--ed5ea","icon":"mobile-featured-link-module--icon--1f55c","title":"mobile-featured-link-module--title--3e9a2"};